import { render, staticRenderFns } from "./addHistoryMail.vue?vue&type=template&id=53d24669&"
import script from "./addHistoryMail.vue?vue&type=script&lang=js&"
export * from "./addHistoryMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports